module.exports = __webpack_public_path__ + "static/media/ng.0ef297b0.svg";